import React from "react";

const Dashboard = React.lazy(() => import("./views/dashboard/Dashboard"));
const Users = React.lazy(() => import("./views/users"));
const Roles = React.lazy(() => import("./views/roles"));
const Modules = React.lazy(() => import("./views/modules"));
const Projects = React.lazy(() => import("./views/projects"));
const Profile = React.lazy(() =>
  import("./components/commons/account/profile")
);

//core modules
const Publishers = React.lazy(() => import("./views/publishers"));
const Advertisers = React.lazy(() => import("./views/advertisers"));
const Tags = React.lazy(() => import("./views/tags"));
const Articles = React.lazy(() => import("./views/articles"));
const WidgetUi = React.lazy(() => import("./views/widget-ui"));
const Ads = React.lazy(() => import("./views/ads"));
const Demand = React.lazy(() => import("./views/demand"));

const routes = [
  { path: "/", exact: true, name: "Home" },
  { path: "/dashboard", name: "Dashboard", component: Dashboard },
  { path: "/users", exact: true, name: "Users", component: Users },
  { path: "/roles", exact: true, name: "Roles", component: Roles },
  { path: "/profile", exact: true, name: "Profile", component: Profile },
  { path: "/projects", exact: true, name: "Projects", component: Projects },
  { path: "/modules", exact: true, name: "Modules", component: Modules },
  { path: "/widget-ui", exact: true, name: "Widget Ui", component: WidgetUi },
  { path: "/ads", exact: true, name: "Ads", component: Ads },
  { path: "/publishers", exact: true, name: "publishers", component: Publishers },
  { path: "/advertisers", exact: true, name: "advertisers", component: Advertisers },
  { path: "/articles", exact: true, name: "articles", component: Articles },
  { path: "/website", exact: true, name: "website", component: Tags },
  { path: "/demand", exact: true, name: "demand", component: Demand },
];
export default routes;
